<div class="dynamicHomePage" *ngIf="isHomePageDynamic === true">
  <div *ngIf="dynamicSections.length">
    <div *ngFor="let section of dynamicSections">
      <div [innerHTML]="section.sanitizedHTML">
      </div>
      <div *ngIf="section.related_products && section.related_products.length">
        <sv-product-card-loader *ngIf="loadingProducts"></sv-product-card-loader>
        <div class="c-productsList" *ngIf="section.fetched_related_products && section.fetched_related_products.length">
          <sv-product-card *ngFor="let product of section.fetched_related_products" [data]="product"
            class="c-productsList__item"></sv-product-card>

          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
          <div class="c-productsList__item c-productsList__item--empty"></div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Vendor Products -->
<div class="vendorProducts" *ngIf="vendor && vendorProducts && vendorProducts.length">

  <h2>{{ vendor.name }}</h2>

  <div *ngIf="loadingVendorProducts">
    <sv-product-card-loader></sv-product-card-loader>
  </div>

  <div class="l-row">
    <div infinite-scroll>
      <div class="c-productsList">
        <ng-template ngFor let-product [ngForOf]="vendorProducts" let-i="index">
          <sv-product-card [data]="product" class="c-productsList__item"></sv-product-card>
        </ng-template>

        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
        <div class="c-productsList__item c-productsList__item--empty"></div>
      </div>
    </div>
  </div>
</div>